import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavContentComponent } from '@reconcept-platform/shared/navigation/nav-content';
import { SectionComponent } from '@reconcept-platform/shared/ui/standalone/page';

@Component({
  selector: 'rcw-not-found',
  template: `
    <!--   show the topbar   -->
    <rcp-nav-content [onlyTop]="true" />
    <div class="view-container">
      <div class="view-main">
        <rcp-section>
          <h1>We konden niet vinden wat je zocht</h1>

          <p>
            Je kunt ons helpen door ons te vertellen wat je zocht en waar je vandaan kwam, via de blauwe knop
            rechtsonderin
          </p>
          <p><a routerLink="/dashboard">Klik hier om naar het dashboard te gaan</a></p>
        </rcp-section>
      </div>
    </div>
  `,
  styles: [
    `
      h1 {
        font-size: 3rem;
      }

      p {
        font-size: 1.2rem;
      }

      * {
        text-align: center;
      }

      .view-container {
        padding: var(--container-padding-desktop);
      }

      .view-main {
        display: flex;
        justify-content: center;
        flex-direction: column;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, NavContentComponent, SectionComponent],
})
export class NotFoundComponent {}
